export const autoOptInEnum = { manual: 0, auto: 1, faceID: 2, noOptIn: 3 }